let $ = jQuery;

import ScrollMagic from 'scrollmagic';
import 'scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap';
import 'scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators';

let AnimationManager = require('../utilities/animation-manager');

let idCare = '#care';

class HomepageCareScience extends AnimationManager {

  constructor() {
    super();
    this.limit = 6;
    this.idTopCare = '#homepage-section-top-care';
    this.idTopScience = '#homepage-section-top-science';
    this.idDeclaration = '#homepage-care-declaration-';
    this.idContent = '#homepage-care-content-';
    this.idImage = '#homepage-care-image-';
    this.idBackgroundCare = '#homepage-background-care';
    this.idBackgroundScience = '#homepage-background-science';
    this.duration = '300px';
    this.offsetTop = '-200px';
    this.offsetBottom = ($('.homepage-section__declaration').height() - 100) + 'px';
  }

  createScenes() {

    for(let i = 1; i <= this.limit; i++) {

      let bottomTransform = 'translate3d(-10vw, -40vh, 0)';
      if(i > 3) {
        bottomTransform = 'translate3d(10vw, -40vh, 0)';
      }

      let sceneTop = new ScrollMagic.Scene({
          triggerElement: this.idDeclaration + i,
          offset: this.offsetTop,
          duration: this.duration
        })
        .setTween(this.idContent + i, {
          transform: 'translate3d(0vw, 0vh, 0)',
          ease: Power1.easeInOut
        }) // trigger a TweenMax.to tween
        // .addIndicators({name: i + ' in (duration: 200px)'}) // add indicators (requires plugin)
        .addTo(this.controller);

      let sceneImage = new ScrollMagic.Scene({
          triggerElement: this.idDeclaration + i,
          offset: this.offsetTop,
          duration: this.duration
        })
        .setTween(this.idImage + i, {
          top: '0px',
          ease: Power1.easeInOut
        }) // trigger a TweenMax.to tween
        // .addIndicators({name: i + ' in (duration: 200px)'}) // add indicators (requires plugin)
        .addTo(this.controller);

      let sceneBottom = new ScrollMagic.Scene({
          triggerElement: this.idDeclaration + i,
          offset: this.offsetBottom,
          duration: this.duration
        })
        .setTween(this.idContent + i, {
          transform: bottomTransform,
          ease: Power1.easeInOut
        }) // trigger a TweenMax.to tween
        // .addIndicators({name: i + ' out (duration: 200px)'}) // add indicators (requires plugin)
        .addTo(this.controller);

    }

    let sceneTopCare = new ScrollMagic.Scene({
        triggerElement: '#care',
        offset: this.offsetTop,
        duration: this.duration
      })
      .setTween(this.idTopCare, {
        top: '0px',
        ease: Power1.easeInOut
      }) // trigger a TweenMax.to tween
      // .addIndicators({name: 'homepage-section-top-care (duration: 200px)'}) // add indicators (requires plugin)
      .addTo(this.controller);

    let sceneTopScience = new ScrollMagic.Scene({
        triggerElement: '#science',
        offset: this.offsetTop,
        duration: this.duration
      })
      .setTween(this.idTopScience, {
        top: '0px',
        ease: Power1.easeInOut
      }) // trigger a TweenMax.to tween
      // .addIndicators({name: 'homepage-section-top-care (duration: 200px)'}) // add indicators (requires plugin)
      .addTo(this.controller);

    let sceneBackgroundCarePinDuration = $('#care').height() - $('#homepage-background-care').height() - 240;

    let sceneBackgroundCarePin = new ScrollMagic.Scene({
        triggerElement: '#care',
        offset: '400px',
        duration: sceneBackgroundCarePinDuration
      })
      .setPin(this.idBackgroundCare)
      // .addIndicators({name: `homepage-section-care background (duration: ${sceneBackgroundCarePinDuration})`}) // add indicators (requires plugin)
      .addTo(this.controller);

    let sceneBackgroundSciencePinDuration = $('#science').height() - $('#homepage-background-science').height() - 240;

    let sceneBackgroundSciencePin = new ScrollMagic.Scene({
        triggerElement: '#science',
        offset: '400px',
        duration: sceneBackgroundSciencePinDuration
      })
      .setPin(this.idBackgroundScience)
      // .addIndicators({name: `homepage-section-science background (duration: ${sceneBackgroundSciencePinDuration})`}) // add indicators (requires plugin)
      .addTo(this.controller);

  }

  destroyScenes() {
    super.destroyScenes();
    for(let i = 1; i <= this.limit; i++) {
      $(this.idContent + i).removeAttr('style');
      $(this.idImage + i).removeAttr('style');
    }
    $(this.idTopCare).removeAttr('style');
    $(this.idTopScience).removeAttr('style');
    $(this.idBackgroundCare).removeAttr('style');
    $(this.idBackgroundScience).removeAttr('style');
  }

}

function init() {
  if($(idCare).length) {
    let homepageCareScience = new HomepageCareScience();
  }
}

if(typeof Drupal === 'undefined') {

  // Initialize for Styleguide
  $(document).ready(() => {
    init();
  });

} else {

  // Export for Drupal
  module.exports = {
    attach: function (context, settings) {
      init();
    }
  };

}
